import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../Contexts/auth.context";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import Image from "../../image/image.component";
import MenuItem from "../menu-item/menu-item.component";
import {
  CMActionsContainer,
  CMList,
  CMMenuList,
  CMNav,
  CMSpace,
  CMDotted,
} from "./menu.styles";
import { ReactComponent as MenuIcon } from "../../../icons/menu.svg";
import { ReactComponent as CloseIcon } from "../../../icons/close.svg";
import { useEffect, useState } from "react";
import { ReactComponent as AuctionIcon } from "../../../icons/Group 308.svg";
import { ReactComponent as TradingIcon } from "../../../icons/money-flow.svg";
import { ReactComponent as PortfolioIcon } from "../../../icons/portfolio (1).svg";
import { ReactComponent as AccountIcon } from "../../../icons/user (1).svg";
import { ReactComponent as SuccessIcon } from "../../../icons/list.svg";
import { ReactComponent as HistoryIcon } from "../../../icons/clock-history.svg";
import { ReactComponent as FundsIcon } from "../../../icons/top-up.svg";
import { ReactComponent as TradeIcon } from "../../../icons/trade.svg";

import { ReactComponent as ListingIcon } from "../../../icons/list.svg";
import { ReactComponent as SupportIcon } from "../../../icons/info-circle.svg";
import { ReactComponent as LogoutIcon } from "../../../icons/chevron-bar-left.svg";
import { ReactComponent as BellIcon } from "../../../icons/bell.svg";
import { ReactComponent as WalletIcon } from "../../../icons/wallet.svg";
import { ReactComponent as UserIcon } from "../../../icons/Group 281.svg";
import { ReactComponent as ArrowIcon } from "../../../icons/close.svg";
import FundsMenuMobile from "../../funds-menu-2/funds-menu-2.component";
import FundsMenuDesktop from "../../funds-menu/funds-menu.component";
import {
  createInfluencer,
  user_profile,
} from "../../../Services/prod/auth.service";
import MessageError from "../../errorMessage/error-modal-window.component";
import { useMediaQuery } from "@mui/material";
import TradeModal from "../../trade-modal/trade-modal.component";
import { getPairList } from "../../../Services/trading-board.service";
import { updateInfluencer } from "../../../Services/prod/promoReferral.service";

const Menu = () => {
  const { currentUser, auth } = useAuth();
  const influencerStatus = localStorage.getItem("isInfluencerProfile");
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const location = useLocation();
  const [showFixedHeader, setShowFixedHeader] = useState(false);
  const [isMyListingsVisible, setIsMyListingsVisible] = useState(false);
  const isMobile = useMediaQuery("(max-width:992px)");
  const [openTrade, setOpenTrade] = useState(false);
  const handleCloseTrade = () => {
    setOpenTrade(false);
  };
  const handleOpenTrade = () => {
    if (process.env.REACT_APP_ENVIRONMENT === "app") {
      getPairList().then((response) => {
        if (response?.data?.pairList && response?.data?.pairList.length != 0) {
          navigate("/trading-board");
        } else {
          navigate("/portfolio");
          setOpenTrade(true);
        }
      });
    } else {
      setTimeout(() => {
        navigate("/trading-board");
        handleMenu();
      }, 1000);
    }
  };

  const handleOpenAdvanceTrading = () => {
    localStorage.removeItem("defaultPair");
    if (process.env.REACT_APP_ENVIRONMENT === "app") {
      getPairList().then((response) => {
        if (response?.data?.pairList && response?.data?.pairList.length != 0) {
          window.location.href = `${window.location.origin}/exchange/symbol/`;
        } else {
          setOpenTrade(true);
        }
      });
    } else {
      setTimeout(() => {
        window.location.href = `${window.location.origin}/exchange/symbol/`;
      }, 1000);
    }
  };

  const handleInfluencerEnroll = async () => {
    try {
      const [createInfluencerRes, updateInfluencerRes] = await Promise.all([
        createInfluencer(),
        updateInfluencer(auth.userId, 1),
      ]);

      if (
        (createInfluencerRes?.status === 200 ||
          createInfluencerRes?.status === 201) &&
        updateInfluencerRes.isSuccess
      ) {
        const userData = JSON.parse(localStorage.getItem("userId")) || {}; 
        localStorage.setItem("userId", JSON.stringify({ ...userData, isInfluencer: "1" }));
        navigate("/influncer-enrollment");
      }
    } catch (error) {
      console.error("Error in handleInfluencerEnroll:", error);
    }
  };
  const linksDesktop = [
    {
      description: "Auction Board",
      link: "auctions-board",
      icon: AuctionIcon,
      hideDesktop: true,
      hideMobile: false,
    },
    // {
    //   description: "Private Auction Board",
    //   link: "private-auction-board",
    //   icon: AuctionIcon,
    //   hideDesktop: true,
    //   hideMobile: false,
    // },
    {
      description: "Sumsub",
      link: "kyc",
      icon: TradingIcon,
      hideDesktop: true,
      hideMobile: false,
    },
    {
      description: "Wallet",
      link: "wallet",
      icon: TradingIcon,
      hideDesktop: true,
      hideMobile: false,
    },
    {
      description: "Trading Board",
      link:"trading-board",
      icon: TradingIcon,
      hideDesktop: true,
      hideMobile: false,
      onClick: () => handleOpenTrade(),
    },
    {
      description: "My Portfolio",
      link: "portfolio",
      icon: PortfolioIcon,
      hideDesktop: true,
      hideMobile: false,
    },
    {
      description: "My Listings",
      link: "dashboard",
      icon: AuctionIcon,
      hideDesktop: true,
      hideMobile: true,
    },
    {
      description: "",
      link: "",
      icon: WalletIcon,
      hideDesktop: false,
      hideMobile: true,
      content: isMobile ? <FundsMenuMobile /> : <FundsMenuDesktop />,
    },
    {
      description: "",
      link: "",
      icon: UserIcon,
      hideDesktop: false,
      hideMobile: false,
      subMenu: [
        {
          description: "Account",
          link: "/account",
          icon: AccountIcon,
        },
        // auth?.isInfluencer === "1" &&
        //   influencerStatus !== "null" && {
        //     description: "Influencer Profile",
        //     link: "/influncer-profile",
        //     icon: AccountIcon,
        //   },
        // auth?.isInfluencer === "0" &&
        //   influencerStatus === "null" && {
        //     description: "Influencer Enroll",
        //     link: "#",
        //     icon: AccountIcon,
        //     onClick: handleInfluencerEnroll,
        //   },
        // auth?.isInfluencer === "1" &&
        //   influencerStatus === "null" && {
        //     description: "Influencer Enroll",
        //     link: "#",
        //     icon: AccountIcon,
        //     onClick: handleInfluencerEnroll,
        //   },
        isMyListingsVisible && {
          description: "My Listings",
          link: "/dashboard",
          icon: ListingIcon,
        },
        {
          description: "History",
          link: "/billing-history",
          icon: HistoryIcon,
        },
        {
          description: "Add Funds",
          link: "#",
          icon: FundsIcon,
        },
        {
          description: "Advance Trading",
          link: `#`,
          icon: TradeIcon,
          onClick: () => handleOpenAdvanceTrading(),
        },
        {
          description: "Support & FAQS",
          link: "/support-center",
          icon: SupportIcon,
        },
        {
          description: "Log Out",
          link: "/logout",
          icon: LogoutIcon,
        },
      ].filter(Boolean),
    },
  ];

  const linksMobile = [
    {
      description: "",
      link: "",
      icon: WalletIcon,
      hideDesktop: false,
      hideMobile: true,
      content: isMobile ? <FundsMenuMobile /> : <FundsMenuDesktop />,
    },
    {
      description: "",
      link: "",
      icon: UserIcon,
      hideDesktop: false,
      hideMobile: false,
      subMenu: [
        {
          description: "Auction Board",
          link: "auctions-board",
          icon: AuctionIcon,
          hideDesktop: true,
          hideMobile: false,
        },
        // {
        //   description: "Private Auction Board",
        //   link: "private-auction-board",
        //   icon: AuctionIcon,
        //   hideDesktop: true,
        //   hideMobile: false,
        // },
        {
          description: "Trading Board",
          //link: "trading-board",
          link: "#",
          icon: TradingIcon,
          hideDesktop: true,
          hideMobile: false,
          onClick: () => handleOpenTrade(),
        },
        {
          description: "My Portfolio",
          link: "portfolio",
          icon: PortfolioIcon,
          hideDesktop: true,
          hideMobile: false,
        },
        auth?.user_accounttype !== "Trader" && {
          description: "My Listings",
          link: "dashboard",
          icon: AuctionIcon,
          hideDesktop: true,
          hideMobile: false,
        },
      ].filter(Boolean),
    },
    {
      description: "",
      link: "",
      icon: UserIcon,
      hideDesktop: false,
      hideMobile: false,
      subMenu: [
        {
          description: "Account",
          link: "/account",
          icon: AccountIcon,
        },
        // auth?.isInfluencer === "1" &&
        //   influencerStatus !== "null" && {
        //     description: "Influencer Profile",
        //     link: "/influncer-profile",
        //     icon: AccountIcon,
        //   },
        // auth?.isInfluencer === "0" &&
        //   influencerStatus === "null" && {
        //     description: "Influencer Enroll",
        //     link: "#",
        //     icon: AccountIcon,
        //     onClick: handleInfluencerEnroll,
        //   },
        // auth?.isInfluencer === "1" &&
        //   influencerStatus === "null" && {
        //     description: "Influencer Enroll",
        //     link: "#",
        //     icon: AccountIcon,
        //     onClick: handleInfluencerEnroll,
        //   },
        {
          description: "History",
          link: "/billing-history",
          icon: HistoryIcon,
        },
        {
          description: "Add Funds",
          link: "#",
          icon: FundsIcon,
        },
        {
          description: "Advance Trading",
          link: `#`,
          icon: TradeIcon,
          onClick: () => handleOpenAdvanceTrading()
        },
        {
          description: "Support & FAQS.",
          link: "/support-center",
          icon: SupportIcon,
        },
      ].filter(Boolean),
    },
    {
      description: "",
      link: "",
      icon: UserIcon,
      hideDesktop: false,
      hideMobile: false,
      subMenu: [
        {
          description: "Log Out",
          link: "/logout",
          icon: LogoutIcon,
        },
      ].filter(Boolean),
    },
  ];

  const [links, setLinks] = useState(linksDesktop);

  useEffect(() => {
    setLinks(isMobile ? linksMobile : linksDesktop);
  }, [isMobile]);

  const handleMenu = () => {
    setOpenMenu(!openMenu);
  };

  useEffect(() => {
    if (auth && auth.user_accounttype) {
      if (auth.user_accounttype === "Trader") {
        setIsMyListingsVisible(false);
      } else {
        setIsMyListingsVisible(true);
      }
    }
  }, []);

  useEffect(() => {
    setOpenMenu(false);
  }, [location.pathname]);

  useEffect(() => {
    // Update the selected menu based on the current location
    const pathname = location.pathname;
    const matchedMenu = links.find((linked) => pathname.includes(linked.link));
    setSelectedMenu(matchedMenu ? matchedMenu.description.toUpperCase() : null);
    //console.log("selected menu", matchedMenu);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      // Set the desired scroll threshold value
      const scrollThreshold = 40;

      // Toggle the visibility of the fixed header based on the scroll position
      setShowFixedHeader(scrollTop > scrollThreshold);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <CMNav>
      <Button
        buttonType={BUTTON_TYPE_CLASSES.TextButton}
        size="small"
        onClick={handleMenu}
      >
        {!openMenu ? (
          <MenuIcon width={24} height={24} />
        ) : (
          <CloseIcon width={24} height={24} />
        )}
      </Button>

      <h5>{selectedMenu}</h5>

      {/* <BellIcon width={24} height={24} className="bellIconPadding" /> */}

      {showFixedHeader && (
        <div className="scrollHeader">
          <Button
            buttonType={BUTTON_TYPE_CLASSES.TextButton}
            size="small"
            onClick={handleMenu}
          >
            {!openMenu ? (
              <MenuIcon width={24} height={24} />
            ) : (
              <CloseIcon width={24} height={24} />
            )}
          </Button>

          <h5 className="scrollViewHeading">{selectedMenu}</h5>

          {/* <BellIcon width={24} height={24} className="fixedHeaderbellIcon" /> */}
        </div>
      )}

      <Link to={""}>
        <Image className="logo_style" src="logo.png" width="147px" />
      </Link>

      {currentUser && (
        <CMList open={openMenu} className={`${openMenu ? "opened" : ""}`}>
          {/* <button onClick={() => (window.location.href = "/exchange")}>
            EXCHANGE
          </button> */}

          <Link to={""} className="mobile-logo dotted-border">
            <Image src="logo.png" width="147px" />
          </Link>

          {/* <CMActionsContainer className="dotted-border">
            <div>
              <p>Cash available</p>
              <p>$14,510</p>
              <Button size="small">Add Funds</Button>
            </div>
            <div>
              <p>Locked Funds</p>
              <p>$20,817</p>
              <Button
                buttonType={BUTTON_TYPE_CLASSES.OutlinedButton}
                size="small"
              >
                Withdraw
              </Button>
            </div>
          </CMActionsContainer> */}

          <>
            {links.map((link, idx) => {
              //console.log(link);
              const Icon = link.icon;
              const shouldHideMyListings =
                link.description === "My Listings" && !isMyListingsVisible;
              const shouldHideSumSub = link.description === "Sumsub";
              const shouldHideWallet = link.description === "Wallet";

              if (
                shouldHideMyListings ||
                shouldHideSumSub ||
                shouldHideWallet
              ) {
                return null;
              }

              return (
                <>
                  <MenuItem
                    key={idx}
                    link={link}
                    className={`${link.hideDesktop ? "hide-lg" : ""}${
                      link.hideMobile ? " hide-sm" : ""
                    }${!link.hideDesktop && link.icon ? "icon-link" : ""}`}
                    onClick={link.onClick}
                  >
                    <Icon width={30} height={30} />
                    {link.description}
                  </MenuItem>
                  {isMobile && idx != 3 && (
                    <CMDotted className="dotted-border" />
                  )}
                </>
              );
            })}
          </>
          {isMobile && <CMSpace />}
        </CMList>
      )}
      <TradeModal open={openTrade} onClose={() => handleCloseTrade()} />
    </CMNav>
  );
};

export default Menu;
